import $ from 'jquery';
import { getPrettyJson } from '../util/scriptUtils';

export class GenerateScriptResponse {
    constructor(request_id, status, script, error) {
        this.request_id = request_id;
        this.status = status;
        this.script = script;
        this.error = error;
    }

    static from_json(jsonResponse) {
        return new GenerateScriptResponse(jsonResponse.request_id, jsonResponse.status, jsonResponse.script, jsonResponse.error);
    }
}

export class ScriptGenerationService {
    
    constructor(component) {
        this.component = component;
    }

    createInitialGenerationRequest(scriptGenerationRequest) {
        return this.performScriptGenerationAction(scriptGenerationRequest, "initialize")
    }

    startScriptGeneration(scriptGenerationRequest) {
        return this.performScriptGenerationAction(scriptGenerationRequest, "start");
    }

    getGenerationResponse(requestId) {
        return this.performScriptGenerationAction({id: requestId}, "status");
    }

    updateScriptGenerationRequest(scriptGenerationRequest) {
        return this.performScriptGenerationAction(scriptGenerationRequest, "update");
    }

    performScriptGenerationAction(request, action) {
        request = {
            ...request,
            schema: request.schema ? request.schema.toJsonString() : null
        }
        const extractionId = this.component.state.currentExtractionId;
        
        let endpoint = null;
        let method = "POST";
        let requestParams = {
            data: JSON.stringify(request),
            contentType: 'application/json',
        };
        
        if (action == "initialize") {
            endpoint = `/api/v1/extractions/${extractionId}/generate/initialize`;
        } else if (action == "start") {
            endpoint = `/api/v1/extractions/${extractionId}/generate/start`;
            method = "PUT";
        } else if (action == "update") {
            endpoint = `/api/v1/extractions/${extractionId}/generate/update`;
            method = "PUT";
        } else {
            endpoint = `/api/v1/extractions/${extractionId}/generate/status/${request.id}`;
            method = "GET";
            requestParams = {};
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                ...requestParams,
                url: endpoint,
                method: method,
                success: (res, textStatus, xhr) => {
                    const generateScriptResponse = GenerateScriptResponse.from_json(res);
                    resolve(generateScriptResponse);
                }
            }).catch(reject);
        });
    }
}

